import axios from "../../../axios";

export function fetchProductList({
  category_code,
  anonymous_id,
  tag_ids = [],
  dynamic_filter_ids = [],
}: {
  category_code: string;
  anonymous_id?: string | null;
  tag_ids?: number[];
  dynamic_filter_ids?: number[];
}) {
  const data: any = {
    category_code: category_code,
    ...(anonymous_id && { anonymous_id }),
    ...(tag_ids.length > 0 && { tag_ids: tag_ids }),
    ...(dynamic_filter_ids.length > 0 && {
      dynamic_filter_ids: dynamic_filter_ids,
    }),
  };

  return axios.post(`/products/list/`, data);
}
